import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import Link from 'next/link'
import { SpecialityRubricCard } from '../../../../../components/SpecialityRubricCard/desktop'
import { useSectionSlug, useSpecialitiesPageRubricsCore } from '../bll'

const SpecialitiesPageRubrics: FC = () => {
  const { isInstitutionsSection } = useSectionSlug()
  const { rubrics, getSpecialityRubricHref, allSpecialitiesRubric } =
    useSpecialitiesPageRubricsCore()

  return (
    <Grid>
      {rubrics.map((rubric) => (
        <GridCol uxs={8} key={rubric.id}>
          <Link href={getSpecialityRubricHref(rubric.id, rubric.slug)} passHref>
            <SpecialityRubricCard isInstitutions={isInstitutionsSection} {...rubric} />
          </Link>
        </GridCol>
      ))}

      {allSpecialitiesRubric && (
        <GridCol uxs={8}>
          <Link
            href={getSpecialityRubricHref(
              allSpecialitiesRubric.id,
              allSpecialitiesRubric.slug
            )}
            passHref
          >
            <SpecialityRubricCard
              isInstitutions={isInstitutionsSection}
              {...allSpecialitiesRubric}
            />
          </Link>
        </GridCol>
      )}
    </Grid>
  )
}

export default memo(SpecialitiesPageRubrics)
